import * as React from "react";
import { SVGProps } from "react";

const Flow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg32"
    x={0}
    y={0}
    viewBox="0 0 256 256"
    {...props}
  >
    <style>{".st1{fill:#fff}"}</style>
    <g id="Layer_2_1_">
      <g id="Layer_1-2">
        <g id="g43" transform="scale(2.56)">
          <circle id="circle20" cx={50} cy={50} r={50} fill="#00ef8b" />
          <path id="rect22" d="M57.8 42.2h14.1v14.1H57.8z" className="st1" />
          <path
            id="path24"
            d="M43.7 61.6c0 2.9-2.4 5.3-5.3 5.3s-5.3-2.4-5.3-5.3 2.4-5.3 5.3-5.3h5.3V42.2h-5.3C27.7 42.2 19 50.9 19 61.6S27.7 81 38.4 81s19.4-8.7 19.4-19.4v-5.3H43.7v5.3z"
            className="st1"
          />
          <path
            id="path26"
            d="M63.1 35.1H79V21H63.1c-10.7 0-19.4 8.7-19.4 19.4v1.8h14.1v-1.8c0-2.9 2.4-5.3 5.3-5.3z"
            className="st1"
          />
          <path id="polygon28" fill="#16ff99" d="M57.8 42.2H43.7v14.1h14.1z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Flow;
